// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "onboarding_migration_job".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
/** Response atom for the "onboarding_migration_job" table (1:1 with a DB row, on the wire). */
export const onboardingMigrationJobAtomSchema = z.object({
    id: z.string(),
    organizationId: z.string(),
    opportunityId: z.string().nullable(),
    code: z.string(),
    status: z.string(),
    invitedAt: z.string().datetime().nullable(),
    skippedAt: z.string().datetime().nullable(),
    clientsConfirmedAt: z.string().datetime().nullable(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
//# sourceMappingURL=onboardingMigrationJob.js.map